import { combineReducers } from "@reduxjs/toolkit";

import { importEmailsListingReducer } from "./importEmailsSlice";

export const importEmailsReducer = combineReducers({
  importEmailsListing: importEmailsListingReducer,
});
